import useRestaurantOptions from './store/useRestaurantOptions';

export const useTimezone = (restaurantUuid = null) => {
  const restaurantOptions = useRestaurantOptions();
  let timezone = null;
  
  if (restaurantUuid) {
    timezone = restaurantOptions.find(restaurant => restaurant.value === restaurantUuid)?.timezone;
  }
  
  if (!timezone) {
    timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  }

  return timezone;
};
